import { useEffect, useState } from "react";
import Header from "@/components/landing/Header";
import Hero from "@/components/landing/Hero";
import Vision from "@/components/landing/Vision";
import Technology from "@/components/landing/Technology";
import Investment from "@/components/landing/Investment";
import InvestorForm from "@/components/landing/InvestorForm";
import Footer from "@/components/landing/Footer";

const Landing = () => {
  const [activeSection, setActiveSection] = useState("hero");

  useEffect(() => {
    const sections = ["hero", "vision", "technologie", "investment", "kontakt"];
    const observers = [];

    sections.forEach((id) => {
      const el = document.getElementById(id);
      if (!el) return;
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) setActiveSection(id);
        },
        { threshold: 0.35 }
      );
      observer.observe(el);
      observers.push(observer);
    });

    return () => observers.forEach((o) => o.disconnect());
  }, []);

  return (
    <div data-testid="landing-page" className="relative">
      <Header activeSection={activeSection} />
      <main>
        <Hero />
        <Vision />
        <Technology />
        <Investment />
        <InvestorForm />
      </main>
      <Footer />
    </div>
  );
};

export default Landing;
